module.exports = __webpack_public_path__ + "static/media/cave.653757f7.svg";